/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Tire Icon component.
 */
export const TireIcon = ({color = dlsColor('grey3'), size = 32}: IconProps) => {
  const {iconColor} = useIconDLS({color});
  return (
    <ThemeIconProvider name='TireIcon' size={size} color={color} legacyIcon={(
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill='none'>
        <circle cx='16.0029' cy='15.9941' r='8.87087' transform='rotate(119.682 16.0029 15.9941)'
          stroke={iconColor}
          strokeWidth='1.5' />
        <circle cx='16.0003' cy='15.9997' r='14.8464' transform='rotate(89.6816 16.0003 15.9997)'
          stroke={iconColor}
          strokeWidth='1.5' />
        <path d='M25.1681 17.3679L21.7173 16.062C20.8543 15.7354 19.8826 15.8945 19.1689 16.4793V16.4793C18.5981 16.9471 18.2544 17.6485 18.2256 18.386V18.386C18.1916 19.2591 18.5918 20.1064 19.2952 20.6249L22.2826 22.827'
          stroke={iconColor}
          strokeWidth='1.5' />
        <path d='M10.1622 8.73201L13.076 11.0833C13.7956 11.664 14.1477 12.5867 13.9977 13.4993V13.4993C13.8786 14.2245 13.4545 14.864 12.8329 15.256L12.7956 15.2795C12.0619 15.7421 11.1491 15.8191 10.3483 15.486L7.05327 14.1151'
          stroke={iconColor}
          strokeWidth='1.5' />
        <path d='M14.4567 25.1952L15.9377 21.2676C16.2637 20.4029 16.101 19.4299 15.5114 18.7183V18.7183C15.0418 18.1516 14.352 17.8131 13.6164 17.7885L13.5802 17.7873C12.7104 17.7581 11.8816 18.1573 11.3622 18.8556L8.99343 22.0404'
          stroke={iconColor}
          strokeWidth='1.5' />
        <path d='M17.871 6.80093L16.5708 9.84982C16.2063 10.7045 16.3363 11.6898 16.91 12.4207V12.4207C17.3597 12.9936 18.0332 13.3465 18.7603 13.3902L18.8116 13.3932C19.6788 13.4453 20.5169 13.0706 21.0563 12.3896L23.0945 9.8167'
          stroke={iconColor}
          strokeWidth='1.5' />
      </svg>
    )} />
  );
};
